import React, { useEffect, useState } from 'react';
import '../../beneficiary.css';
import { Modal, Spinner } from "react-bootstrap";
import InputFieldWithSuffix from '@components/common/InputFieldWithSuffix';
import Button from '@components/common/Button';
import { useSelector } from 'react-redux';
import { RootState } from '@store/reducers';
import { postDataJSON } from '@services/CommonApiService';
import endpoints from '@config/endpoints';
import { errorLogger } from '@utils/applicationLogUtils';
import { toast } from 'react-toastify';
import InfoBar from '@components/common/InfoBars';
import { useDispatch } from 'react-redux';
import { setAbhaAddress } from '@store/actions/beneficiaryAction';
import { decodeWithKeyAndShift } from '@utils/base64Utils';
import { benef_error_const } from '@constants/beneficiaryConstant';



interface showModalProps {
    showModal: boolean;
    handleClose: (type:any) => void;
    value:string;
    title:string;
    suffix:string;
    handleChange:(value: string,event?:any) => void;
};

const CustomiseAbhaAddressModal = ({ showModal, handleClose, value,title,suffix,handleChange}: showModalProps) => {
    const dispatch=useDispatch();
    const [abhaAddressField, setAbhaAddressField] = useState<string>(value);
    const [arrayOfSuggestedNames, setArrayOfSuggestedNames] = useState([]);
    const [errorMessage, setErrorMessage] = useState<string>('');
    const [showError, setShowError] = useState<boolean>(false);
    const [showSpinner, setSHowSpinner] = useState<boolean>(false);
    const txnIdForAbhaAddress = useSelector((state: RootState) => state.beneficiary?.txnIdForAbhaAddress);

    
    useEffect(() => {
        setAbhaAddressField(value);
    }, [value]);

    const createErrorMessage = (abdmMessage: string, rchMessage?: string) => (
        <div>
            <p><strong>ABDM:</strong> {abdmMessage}</p>
            {rchMessage && <p><strong>JANANI:</strong> {rchMessage}</p>}
        </div>
    );

     const handleError = (message: string, rchMessage?: string) => {
            const errorMessage = createErrorMessage(message, rchMessage);
            toast.error(errorMessage, {
                position: "top-center",
            });
            setSHowSpinner(false);
        };

    const fetchSuggestedAbhaAddresses = async () =>{
        try {
            setSHowSpinner(true);
            if (txnIdForAbhaAddress) {
                const data = {
                    id: txnIdForAbhaAddress,
                }
                const response: any = await postDataJSON(`${endpoints.getCustomAbhaAddressSuggestions}`, data);
                const decodedData = JSON.parse(decodeWithKeyAndShift(response.data));
                if (decodedData?.txnId){
                setArrayOfSuggestedNames(decodedData?.abhaAddressList ?? []);
                setSHowSpinner(false);
                }
                else if(decodedData?.message.includes('Invalid Transaction Id')){
                    handleError(decodedData?.message);
                }
                else if(decodedData?.message.includes('Invalid Credentials')){
                    handleError(decodedData?.description);
                }
                else if (decodedData?.message?.includes('Runtime Error')) {
                    handleError(`${decodedData?.code} - ${decodedData.message}`);
                }
                else if (decodedData?.message?.includes('No access token provided')) {
                    handleError(`${decodedData?.code} - ${decodedData.message}`);
                }
                else if (decodedData?.message?.includes('Not Found')) {
                    handleError(`${decodedData?.code} - ${decodedData.description}`);
                }
                else {
                    handleError(decodedData?.message ?? 'Failed to generate suggested ABHA address.')
                }
                
            } else {
                setSHowSpinner(false);
                handleError("Transaction id not available");
            }
        }
        catch(error:any){
            const decodedData = JSON.parse(decodeWithKeyAndShift(error));
            const res = decodedData;
            let catchErrorMessage = '';
            if(res?.message && res?.code){
                catchErrorMessage =`${res?.code} - ${res?.message}`
            }else if(res?.message && !res?.code){
                catchErrorMessage =`${res?.message}`
            }else if(res?.loginId){
                catchErrorMessage =`${res?.loginId}`
            }else if(res?.Aadhaar){
                catchErrorMessage =`${res?.Aadhaar}`
            }else{
                catchErrorMessage = benef_error_const.genericAbdmMessage
            } 
            handleError(catchErrorMessage);
            errorLogger(res, "Custom Abha Address suggestion-getCustomAbhaAddressSuggestions");
        }
    }

    useEffect(()=>{
        fetchSuggestedAbhaAddresses();
    },[])
    

    const handleClick = async () =>{
        const regex = /^[a-zA-Z0-9._]{8,18}$/;
        if(abhaAddressField.length === 0){
            setShowError(true);
            setErrorMessage('Abha Address cannot be blank.')
        }else if(!regex.test(abhaAddressField)){
            setShowError(true);
            setErrorMessage('Entered Abha Address violates one of the condition.')
        }
        else{
            setShowError(false);
            dispatch(setAbhaAddress(`${abhaAddressField}${suffix}`));
            try {
                if(txnIdForAbhaAddress && abhaAddressField){
                    const data = {
                        txnId: txnIdForAbhaAddress,
                        abhaAddress:`${abhaAddressField}`
                    }
                    const response: any = await postDataJSON(`${endpoints.createCustomAbhaAddress}`, data);
                    const decodedData = JSON.parse(decodeWithKeyAndShift(response.data));
                    if(decodedData?.txnId && decodedData?.preferredAbhaAddress){
                        handleClose('submit');
                    }
                    else if (decodedData?.message?.includes('Invalid Transaction Id')){
                        handleError(decodedData?.message);
                    }
                    else if (decodedData?.message?.includes('Invalid Credentials')){
                        handleError(decodedData?.description);
                    }
                    else if (decodedData?.message?.includes('No access token provided')) {
                        handleError(`${decodedData.message}`);
                    }
                    else if (decodedData?.message?.includes('Not Found')) {
                        handleError(`${decodedData?.code} - ${decodedData.description}`);
                    }
                    else if (decodedData?.message?.includes('already exists')){
                        handleError(decodedData?.message);
                    }
                    else{
                        handleError(decodedData?.message ?? 'Failed to create new ABHA Address');
                    }
                }
            } catch (error) {
                const decodedData = JSON.parse(decodeWithKeyAndShift(error));
                const res = decodedData;
                let catchErrorMessage = '';
                if(res?.message && res?.code){
                    catchErrorMessage =`${res?.code} - ${res?.message}`
                }else if(res?.message && !res?.code){
                    catchErrorMessage =`${res?.message}`
                }else if(res?.loginId){
                    catchErrorMessage =`${res?.loginId}`
                }else if(res?.Aadhaar){
                    catchErrorMessage =`${res?.Aadhaar}`
                }else{
                    catchErrorMessage = benef_error_const.genericAbdmMessage
                } 
                handleError(catchErrorMessage);
                errorLogger(res, "Create Custom Abha Address-createCustomAbhaAddress");
            }
            
        }

    }

    const handleSuggestionClick = (suggestion: string) => {
        setAbhaAddressField(suggestion);
    }

    const handleInputChange = (e:any) => {
        setAbhaAddressField(e)
    }

    return (
        <>
            <div className="modal_gender_beneficiaries">
                <Modal
                    show={showModal}
                    onHide={() => handleClose('close')}
                    dialogClassName={'custom-abha-address-modal'}
                    centered={true}
                >
                    <Modal.Header>
                        <div style={{ display: "flex", justifyContent: "space-between", gap: "400px" }}>
                            <div className="d-flex align-items-center beneficiary_back_button" onClick={() => handleClose('close')}>
                                <i className="bi bi-arrow-left" style={{ cursor: "pointer" }} ></i>
                                <span className="ms-1">Back</span>
                            </div>
                            <div className="d-flex align-items-center beneficiary_discard_button" onClick={() => handleClose('close')}>
                                <span className="me-0">Discard</span>
                                <i className="bi bi-x" ></i>
                            </div>

                        </div>
                    </Modal.Header>

                    <Modal.Body  >
                        <div className='custom-abha-address-modal-container'>
                            <h4 className='demographic_headings custom-abha-address-modal-heading'>Customize ABHA address</h4>
                            <InputFieldWithSuffix
                                placeholder={title}
                                labelName={title}
                                value={abhaAddressField}
                                suffix={suffix}
                                onChange={handleInputChange}
                                showButton={false}
                            />
                            {
                                showError && <InfoBar variant="danger" message={errorMessage} className="input_field_class"/>
                            }
                            <p className='demographic_headings custom-abha-address-modal-sub-heading'>Suggestions</p>
                            { showSpinner ? <Spinner /> :
                                <div className='custom-abha-suggestion-container'>
                            {arrayOfSuggestedNames.length > 0 ? arrayOfSuggestedNames.map((item:any, index)=>(
                                <>
                                <span className='suggested-address' onClick={()=>handleSuggestionClick(item)}>{item}</span>
                                {index < item.length - 1 && <span>, </span> }
                                </>
                            )) : <span>No Suggestions available</span>}
                            </div>}
                            <p className='custom-abha-rule'>To create ABHA address, it should have Min - 8 characters,<br/> Max - 18 characters allowed - 1 dot(.) and/or 1 underscore(_)</p>
                            <Button
                                onClick={handleClick}
                                buttonName='Customize ABHA address'
                                colorType='primary'
                                id="customize-btn-on-modal"
                                disabled={abhaAddressField === value}
                            />
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        </>
    );
};

export default CustomiseAbhaAddressModal;